export const VIEW_BILLING_PAGES = 'src/Correspondent/Billing/action/View_Billing_Pages';
export const VIEW_BILLING_PAGES_SUCCESS = 'src/Correspondent/Billing/action/View_Billing_Pages_Success';
export const VIEW_BILLING_PAGES_FAILURE = 'src/Correspondent/Billing/action/View_Billing_Pages_Failure';
export const viewPage = (data) => {
    return {
        type: VIEW_BILLING_PAGES,
        data
    }
}
export const viewPageSuccess = (data) => {
    return {
        type: VIEW_BILLING_PAGES_SUCCESS,
        data
    }
}
export const viewPageFailure = (data) => {
    return {
        type: VIEW_BILLING_PAGES_FAILURE,
        data
    }
}

export const DOWNLOAD_BILLING_DETAILS_EXCEL = 'src/Correspondent/Billing/action/Download_Billing_Details_Excel';
export const DOWNLOAD_BILLING_DETAILS_EXCEL_SUCCESS = 'src/Correspondent/Billing/action/Download_Billing_Details_Excel_Success';
export const DOWNLOAD_BILLING_DETAILS_EXCEL_FAILURE = 'src/Correspondent/Billing/action/Download_Billing_Details_Excel_Failure';

export const downloadBillingDetails = (data) => {
    return {
        type: DOWNLOAD_BILLING_DETAILS_EXCEL,
        data
    }
}
export const downloadBillingDetailsSuccess = (data) => {
    return {
        type: DOWNLOAD_BILLING_DETAILS_EXCEL_SUCCESS,
        data
    }
}
export const downloadBillingDetailsFailure = (data) => {
    return {
        type: DOWNLOAD_BILLING_DETAILS_EXCEL_FAILURE,
        data
    }
}

export const FETCH_CORRESPONDENT_LIST_BILLING = 'src/Admin/Billing/action/Fetch_Correspondent_List';
export const FETCH_CORRESPONDENT_LIST_BILLING_SUCCESS = 'src/Admin/Billing/action/Fetch_Correspondent_List_Billing_Success';
export const FETCH_CORRESPONDENT_LIST_BILLING_FAILURE = 'src/Admin/Billing/action/Fetch_Correspondent_List_Billing_Failure';

export const fetchCorrespondentListBilling = (data) => {
    return {
        type: FETCH_CORRESPONDENT_LIST_BILLING,
        data
    }
}
export const fetchCorrespondentListBillingSuccess = (data) => {
    return {
        type: FETCH_CORRESPONDENT_LIST_BILLING_SUCCESS,
        data
    }
}
export const fetchCorrespondentListBillingFailure = (data) => {
    return {
        type: FETCH_CORRESPONDENT_LIST_BILLING_FAILURE,
        data
    }
}